import axios from 'axios';

// Determine the base URL based on environment
const getBaseUrl = () => {
  // Use environment variable if available
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Otherwise use relative paths
  return '';
};

// Create axios instances
const API = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor for authentication
API.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Debug logging in development
  if (process.env.NODE_ENV !== 'production') {
    console.log(`API Request: ${config.method.toUpperCase()} ${config.baseURL}${config.url}`);
  }
  
  return config;
});

// Add response interceptor for error handling
API.interceptors.response.use(
  response => response,
  error => {
    // Handle common errors (authentication, server issues)
    if (error.response) {
      if (error.response.status === 401) {
        // Clear invalid tokens on authentication errors
        localStorage.removeItem('token');
        // Optionally redirect to login
      }
      
      if (process.env.NODE_ENV !== 'production') {
        console.error('API Error:', error.response.status, error.response.data);
      }
    }
    
    return Promise.reject(error);
  }
);

// Override global axios defaults for legacy code
axios.defaults.baseURL = getBaseUrl();

// Export both the API instance and utility functions
export default API;

export const endpoints = {
  // Authentication
  login: '/api/v1/auth/login',
  register: '/api/v1/auth/register',
  profile: '/api/v1/users/me',
  
  // Claude integration
  claudeDirect: '/api/v1/claude-direct',
  transformation: '/api/v1/transformation',
  claude: '/api/v1/claude',
  generate: '/generate',
  
  // Health check
  health: '/api/v1/health'
};
